import React, { useState, useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";

import NavbarCustomer from "components/NavbarCustomer";
import SidebarCustomer from "components/SidebarCustomer";
import { user, customer } from "localStorage";
import notificationService from "services/notificationService";

const CustomerLayout = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const [isSidebarOpen, setIsSidebarOpen] = useState(isNonMobile);
  const _user = user();
  const _customer = customer();

  useEffect(() => {
    const customerId = _customer?._id;
    if (customerId) {
      notificationService.connect(customerId);
    }
    return () => notificationService.disconnect();
  }, []);
  // const { data } = useGetUserIdQuery(_user._id);

  return (
    <Box display="flex" width="100%" height="100vh" overflow="hidden">
      <SidebarCustomer
        customer={_customer || {}}
        isNonMobile={isNonMobile}
        drawerWidth="250px"
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="column"
        height="100vh"
        overflow="hidden"
      >
        <NavbarCustomer
          user={_user || {}}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <Box flexGrow={1} overflow="auto">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerLayout;
